import React from 'react';
import { FaArrowRight } from 'react-icons/fa';
import { connect } from 'react-redux';
import { TranslateWorkaround } from '../../assets/constants/strings';
import TabIndexBtn from '../Buttons/TabIndex';
import './style.scoped.scss';

const Tile = ({ level, index, toggleDisplayDocuments, tiles }) => {
  const sass =
    tiles && tiles.length > 0
      ? 'wf-tile__image'
      : 'wf-tile__image img_' + index;

  return (
    <TabIndexBtn
      handleClick={() => toggleDisplayDocuments(level)}
      css='wf-tile col-sm-3 my-3'
    >
      <div
        className={sass}
        style={{
          backgroundImage:
            tiles && tiles.length > 0 ? `url(${tiles[index].URL})` : null,
          position: 'relative',
        }}
      >
        {tiles && tiles.length > 0 ? <div className='dynamic'></div> : null}
      </div>
      <div className='wf-tile__text'>
        <p className={`m-0${TranslateWorkaround(level.Title)}`}>
          {level.Title}
        </p>
        <div className='circle'>
          <FaArrowRight className='circle__icon' />
        </div>
      </div>
    </TabIndexBtn>
  );
};

const mapStateToProps = (state) => ({
  tiles: state.client.tiles,
});

const connector = connect(mapStateToProps, null);

export default connector(Tile);
